<template>
    <div class="col-12">
        <transition name="fade" mode="out-in">
            <div class="row" v-if="!loading" key="mapa-butacas" id="mapa-butacas">
                <div class="col-12 mb-2 p-0 d-md-flex d-block justify-content-between">
                    <h3>Seleccione las butacas para asignarles precios:</h3>
                </div>
                <div class="lightgray-content col-12 p-2">
                    <LeafletComponent
                        :plazasSeleccionadas="butacasSeleccionadas"
                        :svgRendered="svgRendered"
                        :originalColor="originalColor"
                        @isPanning="(e) => isPanning = e"
                    />
                </div>
                <div class="col-6 p-0 pt-3 d-flex justify-content-between">
                    <button class="btn mr-1" style="width: 50%;" @click="seleccionarTodasLasButacas">Seleccionar todas</button>
                    <button v-if="butacasSeleccionadas.length > 0" class="btn" style="width: 50%;" @click="limpiarTodasLasButacas">Limpiar todas</button>
                </div>
                <div class="col-12 p-0 pt-3" v-if="butacasSeleccionadas.length > 0">
                    <b-card>
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input pr-5" type="checkbox" id="checkbox_permitir_liberacion_asientos" v-model="seleccionarTodas"/>
                            <label for="checkbox_permitir_liberacion_asientos" class="custom-control-label">
                                Cambiar precio en todas
                            </label> 
                        </div>
                        <PorPlazas
                            :entradas="entradas"
                            :plazas="butacasSeleccionadas"
                            :key="reloadComponent"
                            :recargar="true"
                            :seleccionarTodas="seleccionarTodas"
                            @recargar="reload()"
                            @getButacas="recargar"
                        />
                    </b-card>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-12 text-center" style="height: 400px">
                    <LoaderComponent/>
                </div>
            </div>                            
        </transition>
    </div>
</template>

<script>
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';
    import PorPlazas from '@/components/backend/eventos/sesiones/plazas/PorPlazas';
    import { claveVisibilidad } from '@/utils/visibilidadReducida';

    export default {
        props: ['recinto_id', 'entradas', 'plazas'],
        data() {
            return {
                loading: false,
                svg: null,
                butacasSeleccionadas: [],
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                ocupadaColor: 'red',
                seleccionadaColor: '#8CA9D9',
                svgRendered: null,
                isPanning: null,
                reloadComponent: 1,
                butacas: null,
                sectores: null,
                seleccionarTodas: false
            }   
        },
        methods: {
            getSvg() {
                this.loading = true;
                const params = {
                    recinto_id: this.recinto_id
                };

                this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), params)
                    .then(res => {
                        this.svg = res.data.svg;
                        this.renderLeafletSvg(this.svg);
                    }).finally(() => this.loading = false)
            },
            renderLeafletSvg(svg) {
                const butacasFiltered = this.plazas.filter(butaca => butaca.svg_id);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');
                const isMobile = window.innerWidth <= 768;

                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const butaca = butacasFiltered.find(butaca => butaca.svg_id == svg_id);

                    if (butaca) {    
                        const title = this.getButacaName(butaca);

                        if (!isMobile) {
                            this.drawPopover(circle, butaca, title);
                        }      

                        if(butaca.precios_online.length === 0 && butaca.precios_taquilla.length === 0) {
                            circle.setAttribute('fill', this.noDisponibleColor);
                        } else {
                            circle.setAttribute('fill', '#0CBA31');
                        }

                        circle.style.cursor = 'pointer';
                        circle.style.transition = 'fill 0.2s';

                        circle.addEventListener('click', () => {
                            let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                            setTimeout(() => {
                                if (!this.isPanning) {
                                    if (!isSeleccionado) {
                                        circle.setAttribute('fill', this.seleccionadaColor);
                                        circle.setAttribute('seleccionado', 'true');
                                    } else {
                                        circle.setAttribute('fill', this.originalColor);
                                        circle.setAttribute('seleccionado', 'false');
                                    }
                                    this.clickButaca(butaca.id);
                                }
                            }, 150);
                        });                 
                    }
                });
                this.svgRendered = tempDiv.firstElementChild;
            },
            clickButaca(butaca_id) {
                let butacaSeleccionada = this.plazas.find(butacas => butacas.id == butaca_id);
                if (butacaSeleccionada) {
                    butacaSeleccionada.seleccionada = butacaSeleccionada?.seleccionada && butacaSeleccionada.seleccionada ? false : true;
                    if (butacaSeleccionada.seleccionada) {
                        this.butacasSeleccionadas.push(butacaSeleccionada)
                    } else {
                        const index = this.butacasSeleccionadas.findIndex(butaca => butaca.id == butacaSeleccionada.id);
                    
                        if (index !== -1) {
                            this.butacasSeleccionadas.splice(index, 1);
                        }
                    }
                }

                this.reload();
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    const nombre = this.$t(claveVisibilidad('visibilidad_reducida.nombre', this.sesionIdRuta, clave => this.$te(clave)));
                    name += '<span class="text-danger"> ' + nombre + '</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            drawPopover(circle, butaca, title = null) {
                if (this.load_panzoom) {
                    let content = '';

                    const preciosOnlineContent = this.generatePriceContent(butaca.precios_online);
                    if (preciosOnlineContent !== '') {
                        content += '<b>Precios online:</b>';
                        content += preciosOnlineContent;
                    }

                    const preciosTaquillaContent = this.generatePriceContent(butaca.precios_taquilla);
                    if (preciosTaquillaContent !== '') {
                        content += '<b>Precios taquilla:</b>';
                        content += preciosTaquillaContent;
                    }

                    const popoverOptions = {
                        title: title,
                        content: content,
                        trigger: 'hover',
                        html: true
                    }

                    new Popover(circle, popoverOptions);
                }
            },
            generatePriceContent(precios) {
                let content = '';

                content += '<ul class="pb-0 mb-0">';
                if (precios.length > 0) {
                    precios.forEach(precio => {
                        content += `<li>${precio.description}: ${precio.price + ' €'}</li>`;
                    });
                } else {
                    content += '<li>No tiene precios configurados</li>'
                }
                content += '</ul>';

                return content;
            },
            seleccionarTodasLasButacas() {
                const butacas = this.svgRendered.querySelectorAll('[id^="butaca"]');
                butacas.forEach(element => {
                    element.setAttribute('fill', this.seleccionadaColor);
                    element.setAttribute('seleccionado', 'true');
                    const svg_id = this.getButacaId(element);
                    const butaca = this.plazas.find(butaca => butaca.svg_id == svg_id);
                    if (butaca && !this.butacasSeleccionadas.some(b => b.id === butaca.id)) {
                        this.butacasSeleccionadas.push(butaca);
                    }
                });
            },
            limpiarTodasLasButacas() {
                const butacas = this.svgRendered.querySelectorAll('[id^="butaca"]');
                butacas.forEach(element => {
                    const svg_id = this.getButacaId(element);
                    const butaca = this.plazas.find(butaca => butaca.svg_id == svg_id);
                    if (butaca) {
                        element.setAttribute('fill', this.originalColor);
                        element.setAttribute('seleccionado', 'false');
                        const index = this.butacasSeleccionadas.findIndex(b => b.id === butaca.id);
                        if (index !== -1) {
                            this.butacasSeleccionadas.splice(index, 1);
                        }
                    }
                });
            },
            reload() {
                this.reloadComponent += 1;
            },
            recargar() {
                this.$emit('recargar')
            }
        },
        computed: {
            sesionIdRuta() {
                return this.$route?.params?.sesion_id ?? null;
            },
            load_panzoom() {
                let load_panzoom = true;
                let userAgent = navigator.userAgent || navigator.vendor || window.opera;

                if(/windows phone/i.test(userAgent)) {
                    load_panzoom = false;
                }
            
                if(/android/i.test(userAgent)) {
                    load_panzoom = false;
                }

                if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    load_panzoom = false;
                }

                return load_panzoom;
            }
        },
        created() {
            this.getSvg();
            this.plazas.forEach(butaca => {
                butaca.seleccionada = false;
                butaca.changed = false;
            });
        },
        components: {
            LeafletComponent,
            PorPlazas
        }
    }
</script>